import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from "./NewPatternCondition.module.css"
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";
import SubmitButtonWarning from "../../UI/SubmitButtonWarning/SubmitButtonWarning";

class NewPatternCondition extends Component  {
    state = {
        pattern_conditions: [],
        pattern_condition: {
            condition_id: null,
            condition_title: '',
            condition_description: ''
        },
        showFailMessage: false,
        failMessage: ''
    };

    componentDidMount() {
        if (this.props.pattern_conditions !== []) {
            this.setState({pattern_conditions: this.props.pattern_conditions});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
    };

    postDataHandler = () => {
        const post = {
            condition_id: this.state.pattern_condition.condition_id,
            condition_title: this.state.pattern_condition.condition_title,
            condition_description: this.state.pattern_condition.condition_description,
        };
        axios.post(apiUrl +'PatternConditions/setPatternCondition?token=' + this.props.token, post)
            .then(response => {
                if (!response.data.message) {
                    this.props.onNewPatternCondition(response.data);
                    this.setState({
                        pattern_condition: {
                            condition_id: null,
                            condition_title: '',
                            condition_description: ''
                        }
                    });
                    this.props.newPatternConditionToggle();
                } else {
                    console.log(response.data.message)
                    this.setState({
                        showFailMessage: true,
                        failMessage: response.data.message
                    });
                }
            });


    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewPatternConditionsBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                style={{marginBottom: 5}}
                                placeholder="Enter the name of the condition you want to create."
                                value={this.state.pattern_condition.condition_title}
                                onChange={(event) => this.setState({pattern_condition: {...this.state.pattern_condition, condition_title: event.target.value}})}
                            />
                            <Form.Control
                                as="textarea"
                                rows="4"
                                placeholder="Include a paragraph or so long description of the condition."
                                value={this.state.pattern_condition.condition_description}
                                onChange={(event) => this.setState({pattern_condition: {...this.state.pattern_condition, condition_description: event.target.value}})}
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newPatternConditionToggle}>Cancel</Button>
                        <SubmitButtonWarning
                            token={this.props.token} userId={this.props.userId}
                            handleSubmit={this.addHandler}
                            failMessage={this.state.failMessage}
                            setShowFailMessage={(show) => this.setState({showFailMessage: show})}
                            showFailMessage={this.state.showFailMessage}
                            postType={{
                                lowercase: "pattern condition",
                                capital: "Pattern Condition",
                                capitalLowercase: "Pattern condition",
                            }}
                            submitButton={
                                <Button className="col-sm-3" variant="outline-primary" onClick={
                                    this.addHandler
                                }>Submit</Button>
                            }
                        />
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewPatternCondition;